// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3XhTc","detailsBorder":"styles_detailsBorder__Dc6EM"};